<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div *ngIf="isBranded ? false : !payload?.properties.hideLabel?.value">
  <label class="flex jcc">
    <span [innerHTML]="payload?.properties.text?.value | tokenToDiv"></span>
  </label>
</div>
<div class="flex flex-row" *ngIf="payload?.properties?.content?.value">
  <div class="flex">
    <label class="flex jcfe fwn">
      <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
    </label>
  </div>
</div>
<div class="flex image-container">
  <!-- Full width image approach -->
  <img
    *ngIf="base64ToDisplay && isImageLoaded"
    style="width: 100%; margin: 0 auto"
    [ngStyle]="{ width: isBranded ? '100%' : '75%' }"
    [ngClass]="{ 'broken-image': _base64 === BROKEN_IMAGE_PATH }"
    [src]="base64ToDisplay | sanitizeUrl"
    (error)="onImageLoadError($event)"
    (click)="onEditImageClicked($event)"
    (load)="onImageLoad($event)"
  />
  <div
    *ngIf="_base64 === BROKEN_IMAGE_PATH && isImageLoaded"
    class="flex flex-nosize aic jcc"
    style="padding-bottom: 20px"
  >
    Image link is broken. Please use a new image or delete this field.
  </div>
  <div class="flex flex-row aic jcc p15 rel" *ngIf="!isImageLoaded">
    <!-- RESERVED: rx-icon is external dependency, disabled for now-->
    <!-- <rx-icon name="icon-spinner"></rx-icon> -->
    &nbsp; Loading...
  </div>

  <div *ngIf="!base64ToDisplay && isImageLoaded">- no image selected -</div>
  <!-- RESERVED: Interface to edit image  -->
  <!-- <rx-icon name="icon-edit" class="dark"></rx-icon> -->
</div>
